import * as yup from 'yup';
export const editEmailValidation = yup.object().shape({
    email: yup.string().email().required('Please enter a valid email address'),
});
